export function encodeQueryData(data: { [index: string]: string | number }) {
    const ret = [];
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const key in data) {
      ret.push(`${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`);
    }
    return ret.join("&");
  }